<template>
  <v-dialog
    v-model="show"
    max-width="450"
    @click:outside="cancel"
    content-class="rounded-xl"
  >
    <v-card
      class="pa-4 px-6 d-flex flex-column align-center gap-8"
      rounded="xl"
    >
      <div class="d-flex flex-column align-center px-6 gap-2">
        <v-icon size="60"> mdi-ticket-percent </v-icon>
        <h5 class="text-center mb-0">Esse ingresso é para meia entrada</h5>
        <template v-if="ticketBlock?.concessionPreVerify">
          <p class="text-center mb-0">
            Para continuar a compra, você precisa comprovar que possui benefício
            de meia entrada.
          </p>
          <p class="text-center mb-0">
            Você será redirecionado para a página para comprovação do benefício.
          </p>
          <v-btn color="primary" block @click="redirectToConcessionVerify">
            Verificar meia entrada
          </v-btn>
        </template>
        <template v-else>
          <p class="text-center mb-0">
            Será necessário comprovar que possui benefício de meia entrada ao
            entrar no evento.
          </p>
        </template>
      </div>
      <div class="d-flex justify-center w-full">
        <v-btn text @click="cancel">Cancelar</v-btn>
        <template v-if="!ticketBlock?.concessionPreVerify">
          <v-spacer />
          <v-btn color="primary" @click="confirm"> Continuar </v-btn>
        </template>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      ticketBlock: null,
      resolve: null,
    };
  },
  methods: {
    async open(ticketBlock) {
      return new Promise((resolve) => {
        this.ticketBlock = ticketBlock;
        this.show = true;
        this.resolve = resolve;
      });
    },
    close() {
      this.show = false;
      this.resolve = null;
      this.ticketBlock = null;
    },
    confirm() {
      this.resolve(true);
      this.close();
    },
    cancel() {
      this.resolve(false);
      this.close();
    },
    redirectToConcessionVerify() {
      this.resolve(false);
      this.$router.push({
        path: "/account/concession",
        query: {
          redirect: this.$route.fullPath,
        },
      });
      this.close();
    },
  },
};
</script>
